import classnames from 'classnames';
import React from 'react';
import { Button, ButtonProps } from 'react-bootstrap';
import styles from './iconButton.module.scss';

interface IconButtonProps extends ButtonProps {
  icon: string;
}

const IconButton = ({ icon, className, ...props }: IconButtonProps) => {
  return (
    <Button {...props} className={classnames(styles.root, className)}>
      <img src={icon} alt="editIcon"></img>
    </Button>
  );
};

export default IconButton;
